var uploadDocuments = {
    attachedFiles: 'Attached Files',
    deleteConfirmation: 'Are you sure you want to delete this file?',
    dragDropText: 'Drag and drop or click to <0>browse</0>',
    exit: 'You have files attached that have not been submitted. Are you sure you want to exit?',
    fileSizeText: "Combined maximum size for all attached files: {{maxFileSize}}",
    fileTypes: 'Supported file types: PNG, JPG, or PDF',
    headerTitle: 'Add Documents',
    maxAttachments: 'Maximum number of attachments: {{maxAttachments}}',
    maxAttachmentsReached: 'You have reached your maximum of {{maxAttachments}} attachments',
    modalTitle: 'Add Documents or Comments',
    noAttachedFiles: 'You have no attached files.',
    noComments: 'No comments added.',
    noFiles: 'No files attached.',
    pagination: 'of',
    pleaseSubmit: 'Please submit these files before adding more.',
    pleaseWait: 'Please wait while we run a security scan on your files.',
    redirect: 'We will automatically redirect you when it’s done',
    sectionOptional: '(optional)',
    supportingComments: 'Supporting Comments',
    supportingDocuments: 'Supporting Documents',
    tapToBrowseDocument: '<0>Tap</0> to browse documents',
    title: 'Please upload any supporting documents. Supporting documents include: receipts for the disputed sale or credit, delivery notices or communications with the Merchant or Provider.',
    uploadApiError: 'We encountered an issue and your files could not be submitted. Please try again later.',
    uploadError: 'There was an issue uploading your files. Please try a different file.',
    uploadSuccess: 'Your files have been successfully submitted.'
};
export default uploadDocuments;
//# sourceMappingURL=uploadDocuments.js.map